import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { EngagementPage } from '../firm/engagement-page';
import { ENGAGEMENT_STEPS } from '../firm/engagement-readiness';
import { FeatureGate } from '../firm/feature-gate';

export const Route = createFileRoute('/clients/$caseId/engagement')({
  // Back from the second factor, the editor opens at the step that asked for it.
  validateSearch: z.object({
    step: z.enum(ENGAGEMENT_STEPS).optional().catch(undefined),
  }),
  component: Engagement,
});

/** A client's tax-advisory contract (ADR-071 § 6), with CHECK-POINT. */
function Engagement() {
  const { caseId } = Route.useParams();
  return (
    <FeatureGate feature="check-point">
      <EngagementPage caseId={caseId} />
    </FeatureGate>
  );
}
